import { cn } from "@/lib/utils";

export const invalidField = "border-red-400 focus:border-red-400 focus:ring-red-400";

export function FieldLabel({
  htmlFor,
  className,
  error,
  errorId,
  children,
}: {
  htmlFor?: string;
  className: string;
  error?: string | false;
  errorId?: string;
  children: React.ReactNode;
}) {
  return (
    <div className={cn(className, "flex items-baseline justify-between gap-3")}>
      <label htmlFor={htmlFor}>{children}</label>
      <span
        id={errorId}
        aria-live="polite"
        className="text-brand-orange-02 truncate text-right text-[13px] leading-none font-semibold"
      >
        {error || ""}
      </span>
    </div>
  );
}
